exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-base-message {\n    max-width: 400px;\n    text-align: left;\n}\n\n.page-base-message .pagetext {\n    font-size:40px;\n}\n\n.page-base-container {\n    position: absolute;\n    height:95%;\n    top: 5%;\n    left: 0px;\n    right: 0px;\n}\n\n#page-base-scroller {\n    /* scrollable area for page content */\n    padding: 0px 15px;\n    height: 100%;\n}\n\n.page-base-container .row {\n    height:100%;\n}\n\n.page-base-container .row .cell {\n    height:100%;\n}\n\n.page-part-container {\n    height:100%;\n}\n\n.page-part-message {\n    position: static;\n}\n\nh1{\n  border-bottom: 1px dashed #000;\n  padding-bottom: 5px;\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/pagebase/component.css
// module id = 796
// module chunks = 0